import { render, staticRenderFns } from "./League.vue?vue&type=template&id=4840fbb2&scoped=true&"
import script from "./League.vue?vue&type=script&lang=js&"
export * from "./League.vue?vue&type=script&lang=js&"
import style0 from "./League.vue?vue&type=style&index=0&id=4840fbb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840fbb2",
  null
  
)

export default component.exports